import config from "../config";
import request, { requestOptions } from "../utils/request";
const baseUrl = `${config.API_ROOT}/app/settings`;

const Settings = {
  async get() {
    const options = await requestOptions("GET", {}, true);
    const url = `${baseUrl}/`;
    return request(url, options);
  },
  async updateSettings(updateData) {
    const options = await requestOptions("POST", updateData, true);
    const url = `${baseUrl}/company`;
    const { data, err } = await request(url, options);
    if (err) {
      throw err;
    }

    return data;
  },
};

export default Settings;
